import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom'

import "./sidebar.scss";

interface IndexInterface {
  menuStorage: any[],
  handleSideMenu: any,
};

const Index: React.FC<IndexInterface> = ({ menuStorage, handleSideMenu }) => {
  const [sideMenuActive, setSideMenuState] = useState(false);

  useEffect(() => {
    handleSideMenu(sideMenuActive);
    // eslint-disable-next-line
  }, [sideMenuActive]);

  const handleCurrentPage = (page: any) => {
    localStorage.setItem('nome_modulo', page.nome);
  };

  return (
    <div
      className={`${sideMenuActive ? "mask" : ""}`}
      onClick={() => setSideMenuState(!sideMenuActive)}
    >
      <div className={`menu ${sideMenuActive ? "slide" : ""}`}>
        <div className="side-logo-container">
          <div
            onClick={() => setSideMenuState(!sideMenuActive)}
            className="icon-side-menu"
          >
            <FontAwesomeIcon icon={faBars} />
          </div>
          <div className="side-logo"></div>
        </div>

        {menuStorage &&
          menuStorage.length > 0 &&
          menuStorage.map((m, index) => {
            return (
              <div key={index} className="menu-module">
                <ul>

                  {m && m.nome != 'Home' ? (
                    // <a onClick={() => handleCurrentPage(m)} href={`/submodulos/${m && m.id}`}>
                    <li onClick={() => handleCurrentPage(m)}>
                      <Link to={`/submodulos/${m && m.id}`}>
                        <img
                          src={require(`../../../assets/icons/${m.icone}`).default}
                          alt="icon"
                        />
                        <span>{m && m.nome}</span>
                      </Link>
                    </li>

                  ) : m && m.url && m.url !== "" ? (
                    // <a onClick={() => handleCurrentPage(m)} href={m && m.url}>
                    <li onClick={() => handleCurrentPage(m)}>
                      <Link to={m.url}>
                        <img
                          src={require(`../../../assets/icons/${m.icone}`).default}
                          alt="icon"
                        />
                        <span>{m && m.nome}</span>
                      </Link></li>
                  ) : (
                    <p>{m && m.nome}</p>
                  )}
                </ul>

                <div className="menu-submodule"></div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Index;